<template>
  <div class="bank_account_area">
    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input type="button" value="金融機関・支店選択" @click="openingBaseModal = true, openingSelectBankModal = true" class = "btn btn-submit">
      </div>
    </div>

    <div class="row">
      <!-- 金融機関名 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require" for="bank_account_bank_name">金融機関名</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_name']}" type="text" name="bank_account[bank_name]" id="bank_account_bank_name" :value="bankName" readonly="readonly">
        <div v-if="errorsHash['bank_name']" class="invalid-feedback">金融機関名 {{ errorsHash['bank_name'][0] }}</div>
      </div>

      <!-- 金融機関コード -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require" for="bank_account_bank_code">金融機関コード</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_code']}" type="text" name="bank_account[bank_code]" id="bank_account_bank_code" :value="bankCode" readonly="readonly">
        <div v-if="errorsHash['bank_code']" class="invalid-feedback">金融機関コード {{ errorsHash['bank_code'][0] }}</div>
      </div>
    </div>

    <div class="row">
      <!-- 支店名 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require" for="bank_account_bank_branch_name">支店名</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_branch_name']}" type="text" name="bank_account[bank_branch_name]" id="bank_account_bank_branch_name" :value="bankBranchName" readonly="readonly">
        <div v-if="errorsHash['bank_branch_name']" class="invalid-feedback">支店名 {{ errorsHash['bank_branch_name'][0] }}</div>
      </div>

      <!-- 支店コード -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require" for="bank_account_bank_branch_code">支店コード</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_branch_code']}" type="text" name="bank_account[bank_branch_code]" id="bank_account_bank_branch_code" :value="bankBranchCode" readonly="readonly">
        <div v-if="errorsHash['bank_branch_code']" class="invalid-feedback">支店コード {{ errorsHash['bank_branch_code'][0] }}</div>
      </div>

      <!-- 科目 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require" for="bank_account_account_type">科目</label>
        <div class="form-check">
          <input id="account-type-normal" class="form-check-input" type="radio" value="1" name="bank_account[account_type]" v-model="accountType">
          <label for="account-type-normal" class="form-check-label">
            普通
          </label>
        </div>
        <div class="form-check">
          <input id="account-type-current" class="form-check-input" type="radio" value="2" name="bank_account[account_type]" v-model="accountType">
          <label for="account-type-current" class="form-check-label">
            当座
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- 口座番号 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require" for="bank_account_account_number">口座番号</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['account_number']}" type="text" name="bank_account[account_number]" id="bank_account_account_number" v-model="accountNumber">
        <div v-if="errorsHash['account_number']" class="invalid-feedback">口座番号 {{ errorsHash['account_number'][0] }}</div>
      </div>

      <!-- 口座名義 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label require" for="bank_account_account_name">口座名義</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['account_name']}" type="text" name="bank_account[account_name]" id="bank_account_account_name" v-model="accountName">
        <p class="note" style="margin-bottom: 0px;">カタカナ、英数、スペース等でご入力ください</p>
        <p class="note" style="margin-bottom: 0px;">通帳等に記載されている正式名でご入力ください</p>
        <p class="note">法人格は略称でご入力ください　例：株式会社〇〇→ｶ)〇〇</p>
        <div v-if="errorsHash['account_name']" class="invalid-feedback">口座名義 {{ errorsHash['account_name'][0] }}
        </div>
      </div>
      <input type="hidden" name="bank_account[bankapi_status]" id="bank_account_bankapi_status" :value="bankApi">
    </div>

    <base-modal
      v-if="openingBaseModal"
    >
      <select-bank-modal
        v-show="openingSelectBankModal"
        :api-key="apiKey"
        @closeModal="closedEvent"
        @openSelectBankBranch = "openSelectBankBranchModal"
        @apiCheck="setValue"
      />
      <!-- 支店検索画面は再レンダリングしたいためv-if -->
      <select-bank-branch-modal
        v-if="openingSelectBankBranchModal"
        :api-key="apiKey"
        :bank-code="tempStorageBankCode"
        @backSelectBankModal="openingSelectBankModal = true, openingSelectBankBranchModal = false"
        @decision="setStorage"
        @apiCheck="setValue"
      />
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '../modal/base_modal.vue'
import SelectBankModal from '../modal/select_bank_modal.vue'
import SelectBankBranchModal from '../modal/select_bank_branch_modal.vue'

export default {
  components: {
    BaseModal,
    SelectBankModal,
    SelectBankBranchModal
  },
  data () {
    return {
      openingBaseModal: false,
      openingSelectBankModal: false,
      openingSelectBankBranchModal: false,
      tempStorageBankName: null,
      tempStorageBankCode: null,
      bankName: document.getElementById('_storage_bank_account_bank_name').value,
      bankCode: document.getElementById('_storage_bank_account_bank_code').value,
      bankBranchName: document.getElementById('_storage_bank_account_bank_branch_name').value,
      bankBranchCode: document.getElementById('_storage_bank_account_bank_branch_code').value,
      bankApi: document.getElementById('_storage_bank_account_bankapi_status').value,
      // erb上で宣言した定数
      apiKey: model['apikey'],
      errorsHash: model['errors']
    }
  },
  computed: {
    // 次へ・前へボタンでの挙動を既存と差異が出ないようにしたかったため、リアクティブにストレージに入力値をセットしている
    accountType: {
      get () {
        if (document.getElementById('_storage_bank_account_account_type').value) {
          return document.getElementById('_storage_bank_account_account_type').value
        } else {
          return 1
        }
      },
      set (value) {
        document.getElementById('_storage_bank_account_account_type').value = value
      }
    },
    accountNumber: {
      get () {
        return document.getElementById('_storage_bank_account_account_number').value
      },
      set (value) {
        document.getElementById('_storage_bank_account_account_number').value = value
      }
    },
    accountName: {
      get () {
        return document.getElementById('_storage_bank_account_account_name').value
      },
      set (value) {
        document.getElementById('_storage_bank_account_account_name').value = value
      }
    }
  },
  methods: {
    openSelectBankBranchModal (value) {
      this.tempStorageBankName = value.bankName
      this.tempStorageBankCode = value.bankCode
      this.openingSelectBankModal = false
      this.openingSelectBankBranchModal = true
    },
    setStorage (value) {
      document.getElementById('_storage_bank_account_bank_name').value = this.tempStorageBankName
      document.getElementById('_storage_bank_account_bank_code').value = this.tempStorageBankCode
      document.getElementById('_storage_bank_account_bank_branch_name').value = value.bankBranchName
      document.getElementById('_storage_bank_account_bank_branch_code').value = value.bankBranchCode
      this.bankName = this.tempStorageBankName
      this.bankCode = this.tempStorageBankCode
      this.bankBranchName = value.bankBranchName
      this.bankBranchCode = value.bankBranchCode
      this.openingSelectBankBranchModal = false
      this.openingBaseModal = false
    },
    setValue (value) {
      if (!value) {
        this.deleteAttribute()
        document.getElementById('_storage_bank_account_bankapi_status').value = value
      }
    },
    closedEvent () {
      this.openingBaseModal = false
      this.openingSelectBankModal = false
      this.bankApi = document.getElementById('_storage_bank_account_bankapi_status').value
    },
    deleteAttribute () {
      document.querySelectorAll("#bank_account_bank_name, #bank_account_bank_code, #bank_account_bank_branch_name, #bank_account_bank_branch_code").forEach((e) => {
        e.removeAttribute('readonly')
      })
    }
  },
  mounted() {
    if (this.bankApi === "false") {
      this.deleteAttribute()
    }
  },
}
</script>
